import { initNamespaceStorage } from 'js-storage';
import window from 'window';

const HIDE_QUOTATION_CONFIRMATION_MODAL_KEY_PREFIX = 'hide-quotation-confirmation-modal';

function cleanupHideQuotationConfirmationModalStorage () {
	const { sessionStorage } = window;

	for (let index = sessionStorage.length - 1; index >= 0; index -= 1) {
		const key = sessionStorage.key(index);

		if (
			key === HIDE_QUOTATION_CONFIRMATION_MODAL_KEY_PREFIX ||
			(key !== null && key.startsWith(`${HIDE_QUOTATION_CONFIRMATION_MODAL_KEY_PREFIX}:`))
		) {
			sessionStorage.removeItem(key);
		}
	}
}

export default function myDmsCleanupSessionStorage () {
	const dmsAmbulanceStorage = initNamespaceStorage('dms-ambulance').sessionStorage;
	dmsAmbulanceStorage.removeAll();
	cleanupHideQuotationConfirmationModalStorage();
}
